(function (factory) {
  const estimator = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = estimator;
  if (typeof document !== 'undefined') estimator.start();
})(function () {
  'use strict';
const {FABRICS,INSULATION,ORIENTATIONS,SHAPES,COMPRESSION_SACK,ATTACHMENT_SET,STUFF_SACK_DISPLAY}=window.SLDEstimatorData.products["trail_winder_modular_add_on"];

  const FIELD_LABELS = Object.freeze({
    'Existing Trail Winder Install\n*\n(required)': 'Existing Install',
    'Fabric/Color\n*\n(required)': 'Fabric',
    'Insulation Weight\n*\n(required)': 'Insulation',
    'Insulation Orientation\n*\n(required)': 'Orientation',
    'Compression Sack\n*\n(required)': 'Compression Sack'
  });

  

  

  

  

  
  const DEFAULTS = Object.freeze({
    Insulation: 'Apex Climashield 2.5',
    'Compression Sack': 'No'
  });
  
  
  const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
  const exactText = (value) => String(value || '').trim();

  function selections(scope) {
    const selected = Object.create(null);
    for (const element of scope.querySelectorAll('select')) {
      const label=Object.keys(FIELD_LABELS).find(key=>key.replace(/\s+/g,' ').trim()===String(element.labels&&element.labels[0]&&element.labels[0].textContent||'').replace(/\s+/g,' ').trim());
      if (!own(FIELD_LABELS, label)) continue;
      selected[FIELD_LABELS[label]] = exactText(element.value);
    }
    return selected;
  }

  function preference(choice, field) {
    const value = choice[field];
    return value === undefined || value === '' ? DEFAULTS[field] : value;
  }

  function formatWeight(ounces) {
    const displayedOunces = Number(ounces.toFixed(1));
    return displayedOunces.toFixed(1) + ' oz / ' + Math.round(displayedOunces * 28.349523125) + ' g';
  }

  function estimate(choice) {
    const fabric = FABRICS[choice.Fabric];
    const insulation = INSULATION[preference(choice, 'Insulation')];
    const shapeName = ORIENTATIONS[choice.Orientation];
    const shape = SHAPES[shapeName];
    const compressionSack = COMPRESSION_SACK[preference(choice, 'Compression Sack')];
    if (!fabric || !insulation || !shape || compressionSack === undefined) return null;

    const areaSqYd = shape.area / 1296;
    const shellWeight = 2 * areaSqYd * fabric.density;
    const apexWeight = areaSqYd * insulation.density;
    const finished = shellWeight + apexWeight + ATTACHMENT_SET;

    return {
      area_sq_in: shape.area,
      shell_weight: shellWeight,
      apex_weight: apexWeight,
      attachment_weight: ATTACHMENT_SET,
      finished_modular_add_on_weight: finished,
      finished_quilt_weight: finished,
      stuff_sack_weight: null,
      stuff_sack_class: 'sized_from_existing_system',
      stuff_sack_display: STUFF_SACK_DISPLAY,
      compression_sack_weight: null,
      compression_sack_class: 'unclassified',
      compression_sack_selected: compressionSack
    };
  }

  function start() {
    const root = document.querySelector('[data-sld-trail-winder-modular-add-on-estimator]');
    if (!root) return;
    const scope = root.closest('product-info') || document;

    function calculate() {
      const result = estimate(selections(scope));
      const results = root.querySelector('[data-sld-estimator-results]');
      const message = root.querySelector('[data-sld-estimator-message]');
      if (!result) {
        if (results) results.hidden = true;
        if (message) message.textContent = 'Select the fabric and insulation orientation to see the estimated weight.';
        return;
      }

      const addOn = root.querySelector('[data-sld-weight-quilt]');
      const stuffSack = root.querySelector('[data-sld-weight-stuff-sack]');
      const compressionSack = root.querySelector('[data-sld-compression-sack]');
      if (addOn) addOn.textContent = formatWeight(result.finished_modular_add_on_weight);
      if (stuffSack) stuffSack.textContent = result.stuff_sack_display;
      if (compressionSack) compressionSack.textContent = result.compression_sack_selected
        ? '2–4 oz / 57–113 g'
        : 'Not selected';
      if (results) results.hidden = false;
      if (message) message.textContent = '';
    }

    let timer;
    const queue = () => {
      clearTimeout(timer);
      timer = setTimeout(calculate, 75);
    };
    document.addEventListener('change', queue, true);
    document.addEventListener('input', queue, true);
    document.addEventListener('click', queue, true);
    new MutationObserver(queue).observe(scope, {
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'checked', 'selected', 'class', 'aria-checked'],
      childList: true
    });
    calculate();
  }

  return {
    COMPRESSION_SACK,
    FABRICS,
    FIELD_LABELS,
    INSULATION,
    ORIENTATIONS,
    SHAPES,
    STUFF_SACK_DISPLAY,
    estimate,
    formatWeight,
    selections,
    start
  };
});
